export enum Role {
  CHERCHEUR = 'CHERCHEUR',
  ADMIN = 'ADMIN',
  MINISTERE = 'MINISTERE'
}
